import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    padding: 0px 16px;
    color: ${colors.prussian};
  `,
  preferenceItem: css`
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    text-decoration: none;
    color: ${colors.prussian};
  `,
  content: css`
    display: flex;
    flex-direction: row;
  `,
  language: css`
    padding-right: 8px;
  `,
  buttonContainer: css`
    display: flex;
    flex-direction: row;
    align-items: center;
  `,
  arrowIcon: css`
    padding: 8px;
  `,
  list: css`
    width: 100%;
  `,
};

export default styles;
